// import MultiTab from '@/components/MultiTab';
import SystemHead from '@/components/SystemHead';

import { defineComponent } from 'vue';
import './index.less';

export default defineComponent({
  name: 'AdminLayout',
  data() {
    return {};
  },
  created() {
    // const userName = sessionStorage.getItem('userName');
    // if (!userName) {
    //   this.$router.push('/auth/login');
    // }
  },
  render() {
    return (
      <>
        <SystemHead />
        <div class="content-wrap">
          {/* <MultiTab defaultRoute={this.$route} /> */}
          <div class="body">
            <router-view key={this.$route.fullPath} />
          </div>
        </div>
      </>
    );
  },
});
